import {
  Avatar,
  // CircularProgress,
  Grid,
  Typography,
} from "@mui/material"
import React from "react"
import useStyles from "./useStyles"
import formatDate from "../../utils/formatDate"

//   import { NavLink } from 'react-router-dom'
//   import ReceiptLongIcon from '@mui/icons-material/ReceiptLong'

export const SuborganizationsBox = ({ data = [], config = [] }) => {
  const classes = useStyles()

  function getComponent(comp, item) {
    switch (comp.type) {
      case "title":
        return (
          <p
            style={{
              fontSize: 17,
              fontWeight: "bold",
              color: "#485450",
              margin: 0,
              padding: 0,
              overflow: "hidden",
              textOverflow: "ellipsis",
              display: "-webkit-box",
              WebkitLineClamp: 3, // Limitar a 3 líneas
              WebkitBoxOrient: "vertical",
              whiteSpace: "normal",
            }}
            key={comp.value}
          >
            {comp.label || item[comp.value]}
          </p>
        )
      case "string":
        return (
          <>
            <p
              style={{
                fontSize: 14,
                margin: 0,
                padding: 0,
                fontWeight: "bold",
              }}
            >
              {comp.label}
            </p>
            <p
              style={{
                fontSize: 14,
                margin: 0,
                padding: 0,
                marginLeft: 5,
                fontWeight: "bold",
                color: "#6e7a76",
              }}
              key={comp.value}
            >
              {item[comp.value]}
            </p>
          </>
        )
      case "boolean":
        return (
          <>
            <p
              style={{
                fontSize: 14,
                fontWeight: "bold",
                margin: 0,
                padding: 0,
              }}
            >
              {comp.label}
            </p>
            <p
              style={{
                fontSize: 14,
                margin: 0,
                padding: 0,
                marginLeft: 5,
                fontWeight: "bold",
                color: "#6e7a76",
              }}
            >
              {item[comp.value] ? "Si" : "No"}
            </p>
          </>
        )
      case "user-date":
        return (
          <>
            <p
              style={{
                fontSize: 14,
                margin: 0,
                padding: 0,
                fontWeight: "bold",
                letterSpacing: 0.3,
              }}
            >
              {comp.label}
            </p>
            <p
              style={{
                fontSize: 14,
                letterSpacing: 0.3,
                margin: 0,
                padding: 0,
                marginLeft: 5,
                fontWeight: "bold",
                color: "#6e7a76",
              }}
              key={comp.value}
            >
              {item[comp.value]
                ? `${item[comp.value]} - ${formatDate(item[comp.date])}`
                : "-"}
            </p>
          </>
        )
      default:
        break
    }
  }
  return (
    <Grid container className={classes.boxDetails}>
      <Grid item xs={12}>
        <Typography
          style={{
            fontSize: 20,
            fontWeight: "bold",
            color: "#4B4952",
            paddingLeft: 10,
            borderBottom: "1px solid rgba(36, 55, 143, 0.2)",
          }}
        >
          Estudios asociados
        </Typography>
      </Grid>
      {data &&
        data.map((suborganization) => (
          <div
            className={classes.boxEstudio}
            key={suborganization.customerSuborganizationCuit}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: 15,
                width: "35%",
              }}
            >
              <Avatar
                src={
                  suborganization.firmSuborganizationBasePictureURL
                    ? `${suborganization.firmSuborganizationBasePictureURL}/${suborganization.firmSuborganizationLogoPictureURL}`
                    : null
                }
                sx={{
                  bgcolor: suborganization.firmSuborganizationAvatar?.color,
                  width: 60,
                  height: 60,
                }}
              >
                {suborganization.firmSuborganizationAvatar?.initials}
              </Avatar>
              <div
                style={{
                  display: "inline-block",
                  alignContent: "center",
                  paddingLeft: 5,
                }}
              >
                {config.leftData?.map((comp) =>
                  getComponent(comp, suborganization),
                )}
              </div>
            </div>

            <div style={{ color: "#485450", paddingLeft: 10, width: "65%" }}>
              {config.rightData?.map((comp) => (
                <div
                  key={comp.label}
                  style={{
                    display: "flex",
                    height: 30,
                  }}
                >
                  {getComponent(comp, suborganization)}
                </div>
              ))}
            </div>
          </div>
        ))}
    </Grid>
  )
}
